import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function ContactSupport(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm1.07-7.75c-.9.92-1.07 1.53-1.07 2.25h-2v-.5c0-1.1.36-1.99 1.28-2.91.9-.9 1.43-1.44 1.43-2.34 0-1.21-.99-2.2-2.2-2.2s-2.2.99-2.2 2.2H8c0-2.32 1.88-4.2 4.2-4.2s4.2 1.88 4.2 4.2c0 1.34-.63 2.09-2.13 3.45z" />
    </SvgIcon>
  )
}
